<script>
import { authComputed } from '@/state/helpers'
import moment from 'moment'
/**
 * Welcome Card component
 */
export default {
  data: () => ({
    order_stats: {
      total: 0,
      this_month: 0,
      last_month: 0,
      incomplete: 0,
      percent_complete: 0
    },
    currentMonth: moment().startOf('month'),
    lastMonth: moment().subtract(1, 'month').startOf('month')
  }),
  mounted () {
    //this.getOrderStats();
  },
  methods: {},
  computed: {
    ...authComputed,
    greeting () {
      const morning = 6
      const afternoon = 12
      const evening = 18
      const night = 23

      const currentHour = parseFloat(moment().format('HH'))

      if (currentHour < morning || currentHour >= night) return 'night'
      if (currentHour >= morning && currentHour < afternoon) return 'morning'
      if (currentHour >= afternoon && currentHour < evening) return 'afternoon'
      if (currentHour >= evening && currentHour < night) return 'evening'
      return 'morning'
    }
  }
}
</script>
<template>
  <div>
    <b-card no-body variant="secondary"
      ><b-card-body
        ><h5 class="mb-1 flex-column d-flex bold">
          {{ $t(`dashboard.welcome.${greeting}`) }}
          {{ userProfile.firstname }}!
        </h5>
        <p class="m-0 small" v-if="userRole === 'user'">
          {{ $t('dashboard.welcome.message') }}
        </p>
      </b-card-body></b-card
    >
  </div>
</template>
